import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TimetrackSelectors, TimetrackDispatchers } from '@store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { Timereg, TimetrackDescription, UgerepDone } from '../store/models';

@Component({
    selector: 'app-time-log',
    template: `
        <app-time-log-ui
            [user]="user$ | async"
            [year]="year$ | async"
            [week]="week$ | async"
            [today]="today$ | async"
            [ugerapport]="ugerapport$ | async"
            [weekTotals]="weekTotals$ | async"
            [normtiderWeek]="normtiderWeek$ | async"
            [ugerepDoneWeek]="ugerepDoneWeek$ | async"
            (saveTimer)="saveTimer($event)"
            (saveBeskrivelse)="saveBeskrivelse($event)"
            (doneDay)="doneDay($event)"
        ></app-time-log-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimeLogContainer {

    user$ = this.timetrackSelector.user$;
    year$ = this.timetrackSelector.year$;
    week$ = this.timetrackSelector.week$;
    today$ = this.timetrackSelector.today$;
    weekTotals$ = this.timetrackSelector.weekTimeTotals$;
    ugerapport$ = combineLatest([
        this.timetrackSelector.ugerapport$,
        this.timetrackSelector.ugerapportFaste$
    ]).pipe(map(([ugerapport, ugerapportFaste]) => [...ugerapport, ...ugerapportFaste]));
    normtiderWeek$ = this.timetrackSelector.normtiderWeek$;
    ugerepDoneWeek$ = this.timetrackSelector.ugerepDoneWeek$;

    constructor(
        private timetrackSelector: TimetrackSelectors,
        private timetrackDispatch: TimetrackDispatchers
    ) {}

    saveTimer(partialTimereg: Partial<Timereg>) {
        this.timetrackDispatch.createTimereg(partialTimereg);
    }

    saveBeskrivelse(timetrackDescription: TimetrackDescription) {
        this.timetrackDispatch.updateTimeregBeskrivelse(timetrackDescription);
    }

    doneDay(ugerepDone: UgerepDone) {
        this.timetrackDispatch.createUgerepDone(ugerepDone);
    }

}
